/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Nov 17 2023
 **/

import React from "react";

import { APIErrorCode, EventID, SidebarID } from "@/frameworks/core/commons";
import { useFullSizeChatManager, useSidebarActions } from "@/frameworks/core/hooks";
import { RestAPIError } from "@/frameworks/libraries/restservice";
import { SearchBarWithHistory } from "@/frameworks/core/components";
import { Column, useToast } from "@/frameworks/designStuff/components";
import { EventHandler } from "@rfice/eventhandler";

export default function ChatSearch({ onClose }: { onClose: () => void }) {
	const sidebarActions = useSidebarActions();
	const { fullSizeChatActions } = useFullSizeChatManager();
	const toast = useToast();

	const handleSubmit = (
		ev: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLParagraphElement>,
		searchValue?: string
	) => {
		ev.preventDefault();
		if (!searchValue || searchValue.trim().length === 0) return;

		try {
			EventHandler.emit(EventID.SEARCH_CHAT, searchValue);
			fullSizeChatActions.hide();
			sidebarActions.show(SidebarID.ChatSearch);
		} catch (err) {
			const error = err as RestAPIError;
			switch (error.code) {
				case APIErrorCode.PARAMETER_NOT_VALID: {
					toast.show({ type: "error", message: "검색 키워드를 확인해주세요" });
					break;
				}
			}
		}
	};

	const handleClose = (searchValue?: string) => {
		if (searchValue && searchValue.length > 0) return;
		onClose();
	};

	return (
		<Column css={{ padding: "8px 16px" }}>
			<SearchBarWithHistory searchKey="chat" onSearch={handleSubmit} onClearText={handleClose} />
		</Column>
	);
}
